import Link from 'next/link';
import { buttonVariants } from '@/components/ui/button';
import { useCurrentUser } from '@/features/auth/hooks/use-current-user';
import { CartMenu } from './cart-menu';
import { MessagesAction } from './messages';
import { ProfileMenu } from './profile-menu';
export function AuthenticatedActions() {
  const {
    data: user
  } = useCurrentUser();
  return <div className="flex gap-2 items-center" data-sentry-component="AuthenticatedActions" data-sentry-source-file="authenticated-actions.tsx">
      {user && <>
          <div className="group hidden sm:flex items-center p-2">
            <Link href="/listings/create" className={buttonVariants({
          variant: 'outline',
          className: 'whitespace-nowrap rounded-s-lg px-7'
        })}>
              Sell Now
              <span className="sr-only">sell your clothes on zaars</span>
            </Link>
          </div>
        </>}
      <MessagesAction data-sentry-element="MessagesAction" data-sentry-source-file="authenticated-actions.tsx" />
      <CartMenu data-sentry-element="CartMenu" data-sentry-source-file="authenticated-actions.tsx" />
      <div className="hidden sm:flex">
        <ProfileMenu data-sentry-element="ProfileMenu" data-sentry-source-file="authenticated-actions.tsx" />
      </div>
    </div>;
}